frontApp.reviewCreate = {
  init() {
    if ($('.js-review-create').length) {
      this.cancelInit();
      this.messageEvents();
      this.starsRatingInit();
    }
  },
  starsRatingInit() {
    const $rating = $('.js-review-create-rating');
    if ($rating.length) {
      $.each($rating, function () {
        $(this).barrating({
          theme: 'css-stars',
          initialRating: 5,
        });
      });
    }
  },
  messageEvents() {
    $('.js-review-create-message').on('input', function () {
      const $curEl = $(this);
      const $curForm = $curEl.closest('.js-review-create');
      $curForm.find('.js-review-create-send').prop('disabled', !$curEl.val().length);
      $curForm.find('.js-review-create-message-current').html($curEl.val().length);
    });
  },
  cancelInit() {
    $('.js-review-create-cancel').on('click', (e) => {
      e.preventDefault();
      this.cancel();
    });
    $('.js-review-create-send').on('click', () => {
      this.cancel();
    });
  },
  cancel() {
    const dialog = Fancybox.getInstance();
    if (dialog) {
      dialog.close();
    }
  },
};
